import Link from "next/link";
import { Layout, Row, Col, Typography, Divider } from "antd";
import { PRODUCT_NAME } from "@/shared/config/labels";

const { Footer } = Layout;
const { Title, Text, Paragraph } = Typography;

export default function SiteFooter() {
  return (
    <Footer style={{ background: "#ffffff", borderTop: "1px solid #f0f0f0", padding: "48px 24px 24px" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <Row gutter={[32, 32]}>
          <Col xs={24} md={12}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span
                style={{
                  display: "flex",
                  height: 32,
                  width: 32,
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: 8,
                  background: "#1677ff",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: 14,
                }}
              >
                ID
              </span>
              <Text strong>{PRODUCT_NAME}</Text>
            </div>
            <Paragraph type="secondary" style={{ marginTop: 16, maxWidth: 400 }}>
              Превращайте статичные документы Word в интерактивные веб-страницы
              с модальными окнами, таблицами и вложениями.
            </Paragraph>
          </Col>
          <Col xs={12} md={6}>
            <Title level={5} style={{ marginBottom: 12 }}>
              Продукт
            </Title>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <Link href="/features"><Text type="secondary">Возможности</Text></Link>
              <Link href="/examples"><Text type="secondary">Примеры</Text></Link>
              <Link href="/faq"><Text type="secondary">Вопросы и ответы</Text></Link>
            </div>
          </Col>
          <Col xs={12} md={6}>
            <Title level={5} style={{ marginBottom: 12 }}>
              Компания
            </Title>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              <Link href="/contact"><Text type="secondary">Контакты</Text></Link>
              <Link href="/faq"><Text type="secondary">Вопросы и ответы</Text></Link>
              <Link href="/admin/login"><Text type="secondary">Вход</Text></Link>
            </div>
          </Col>
        </Row>
        <Divider style={{ margin: "32px 0 16px" }} />
        <Text type="secondary" style={{ display: "block", textAlign: "center" }}>
          © {new Date().getFullYear()} {PRODUCT_NAME}. Все права защищены.
        </Text>
      </div>
    </Footer>
  );
}
